import React, {Component} from "react";
import {Formik, Form, Field} from "formik";
import "react-datepicker/dist/react-datepicker.css";
import {Badge, Button} from "reactstrap";
import {Link} from "react-router-dom";
import {OETModalHistory} from "../../../sode/oet";
import {utils} from "~/utils";
import {service} from "../redux";
import CircleLoader from "react-spinners/CircleLoader";
import VoaItemsModal from "./voa_item_modal";
// import swal from "sweetalert";
import ScratchPOModal from "./scratch_po_modal";

const initValues = (non_sode, oet, run, pr_approved_date) => {
    let res = {
        number: "",
        approval_date: "",
        purchasing_group: "",
        sap_top_wbs: "",
        name: "",
        profit_center: "",
        base_id: "",
        wbs_expiry_date: '',
    };
    if (!!non_sode) {
        res = {
            ...res,
            number: non_sode.non_sode.id,
            approval_date: utils.renderDate(non_sode.non_sode.approval_date)
        };
    }
    if (!!oet) {
        if (oet && oet.customer_purchase_order) {
            const pg = oet.purchasing_group;
            const name = oet.name ? oet.name : "";
            const stwbs = oet.sap_top_wbs;
            const wbs_expiry_date = oet.wbs_expiry_date ? oet.wbs_expiry_date : ''
            res = {
                ...res,
                name,
                purchasing_group: pg ? pg : "",
                sap_top_wbs: stwbs ? stwbs : "",
                wbs_expiry_date: utils.renderDate(wbs_expiry_date) ? oet.wbs_expiry_date : '',
            };
        }
    }
    if (run) {
        const {base_id, profit_center} = run;
        res = {
            ...res,
            profit_center: profit_center ? profit_center : "",
            base_id: base_id ? base_id : ""
        };
    }
    return res;
};

export default class NonSodeTracker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading_oet_report: false,
            pr_approved_date: null
        };
    }

    static header = (collapse, props) => {
        const {oet, run} = props;
        let status_display = "";
        let newVal = "";
        if (run) {
            status_display = run.status_display;
            switch (run.action) {
                case "partial_cancel":
                    newVal = "Partially Cancel";
                    break;
                case "amend":
                    newVal = "Amend";
                    break;
                default:
                    break;
            }
        } else if (oet) {
            status_display = oet.status_display;
        }
        return (
            <nav className="navbar">
                <span className="navbar-brand h4">{run ? "OET Info" : "NON SODE Tracker"}</span>
                <div>
                    {oet && run && run.original_run && (
                        <span style={{margin: "0 8px"}}>
                            Original Run ID:{" "}
                            <Link to={`/run/${oet.id}/${run.original_run.id}`}>Run #{run.original_run.number}</Link>
                        </span>
                    )}
                    {run && run.original_run && (
                        <span style={{margin: "0 8px"}}>
                            Creation: <Badge color="primary">{newVal}</Badge>
                        </span>
                    )}
                    <span>
                        Status: <Badge color="info">{status_display}</Badge>
                    </span>
                </div>
            </nav>
        );
    };

    openComments = () => {
        const {run, user, commentsModal} = this.props;
        commentsModal.toggle({
            requestData: {
                content_type: 21,
                object_id: run.id,
                user
            },
            withOnSend: false
        });
    };

    get_pr_approved_date = run => {
        if (run) {
            const {pr_approved_date} = run;
            let date = null;
            if (pr_approved_date) {
                date = this.state.pr_approved_date ? this.state.pr_approved_date : utils.strToDate(pr_approved_date);
            }
            return date;
        }
        return null;
    };
    

    render() {
        const {
            oet,
            run,
            status,
            onSubmit,
            onCancel,
            nonSode
        } = this.props;
        const pr_approved_date = this.get_pr_approved_date(run);
        const init_values = initValues(nonSode, oet, run, pr_approved_date);
        return (
            <div className={["tracker_filters", this.props.className].join(" ")}>
                <div className="content">
                    <Formik
                        initialValues={init_values}
                        enableReinitialize={true}
                        onSubmit={(values, cmp) => this.handleSubmit(onSubmit, values, cmp)}
                    >
                        {formik => {
                            return (
                                <Form>
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label>Approval ID</label>
                                            <Field name="number" type="text" disabled className="form-control"/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label>Approval Date</label>
                                            <Field name="approval_date" type="text" disabled className="form-control"/>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-4">
                                            <div className="form-group">
                                                <label>OET Name</label>
                                                <Field
                                                    name="name" 
                                                    type="text"
                                                    className="form-control"
                                                    disabled={!run ? status > 1 : status > 0}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row">

                                        {status >= 0 && (
                                            <div className="col-12 col-sm-12 col-md-4">
                                                <div className="form-group">
                                                    <label>SAP Top WBS</label>
                                                    <Field
                                                        name="sap_top_wbs"
                                                        type="text"
                                                        className="form-control"
                                                        disabled={run || status > 1}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        
                                        {status >= 0 && (
                                            <div className="col-12 col-sm-12 col-md-4">
                                                <div className="form-group">
                                                    <label>WBS expiry date</label>
                                                    <Field name="wbs_expiry_date" type="text" disabled className="form-control"/>
                                                </div>
                                            </div>
                                        )}

                                        {/*<div className="col-12 col-sm-12 col-md-4">*/}
                                        {/*    <div className="form-group">*/}
                                        {/*        <label>Purchasing group</label>*/}
                                        {/*        <Field*/}
                                        {/*            name="purchasing_group"*/}
                                        {/*            type="text"*/}
                                        {/*            className="form-control"*/}
                                        {/*            disabled={!run ? status > 1 : status > 0}*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*{status >= 0 && (*/}
                                        {/*    <div className="col-12 col-sm-12 col-md-4">*/}
                                        {/*        <div className="form-group">*/}
                                        {/*            <label>SAP Top WBS</label>*/}
                                        {/*            <Field*/}
                                        {/*                name="sap_top_wbs"*/}
                                        {/*                type="text"*/}
                                        {/*                className="form-control"*/}
                                        {/*                disabled={run || status > 1}*/}
                                        {/*            />*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                        {/*{status >= 4 && run && (*/}
                                        {/*    <div className="col-12 col-sm-12 col-md-4">*/}
                                        {/*        <div className="form-group">*/}
                                        {/*            <label>BASE ID</label>*/}
                                        {/*            <Field*/}
                                        {/*                name="base_id"*/}
                                        {/*                type="text"*/}
                                        {/*                min={0}*/}
                                        {/*                step={1}*/}
                                        {/*                className="form-control"*/}
                                        {/*                disabled={status !== 4}*/}
                                        {/*            />*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                    </div>
                                    <div className="row">
                                        {/*{status >= 4 && run && (*/}
                                        {/*    <div className="col-12 col-sm-12 col-md-4">*/}
                                        {/*        <div className="form-group">*/}
                                        {/*            <label>Profit Center</label>*/}
                                        {/*            <Field*/}
                                        {/*                name="profit_center"*/}
                                        {/*                type="text"*/}
                                        {/*                min={0}*/}
                                        {/*                step={1}*/}
                                        {/*                className="form-control"*/}
                                        {/*                disabled={status !== 4}*/}
                                        {/*            />*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*)}*/}
                                    </div>
                                    <div className="row controls">
                                        {!run && (
                                            <Button
                                                color="danger"
                                                type="button"
                                                onClick={ev => {
                                                    onCancel();
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        )}
                                        <div style={{flex: "1 0 auto"}}/>
                                        {run && oet && (
                                            <React.Fragment>
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    onClick={ev => {
                                                        if (oet) {
                                                            this.setState({loading_oet_report: true});
                                                            service
                                                                .download(run, oet)
                                                                .then(() => {
                                                                    this.setState({loading_oet_report: false});
                                                                })
                                                                .catch(() => {
                                                                    this.setState({loading_oet_report: false});
                                                                });
                                                        }
                                                    }}
                                                >
                                                    Download OET 
                                                </Button>
                                                <CircleLoader
                                                    loading={this.state.loading_oet_report}
                                                    color={"#007bff"}
                                                />
                                            </React.Fragment>
                                        )}
                                        {!run && oet && <OETModalHistory oet_logs={oet.state_logs}/>}
                                        {run && <OETModalHistory oet_logs={run.state_logs}/>}
                                        {(status === 0 || (status === 1 && !run) || status === 4 || status === 5) &&
                                        onSubmit && (
                                            <Button color="primary" type="submit">
                                                Save
                                            </Button>
                                        )}
                                        {status === 4 && (
                                            <React.Fragment>
                                                {run && (
                                                    <VoaItemsModal
                                                        buttonLabel="Sync VOA"
                                                        run={run.id}
                                                        updatePage={this.props.updatePage}
                                                    />
                                                )}
                                                {run && !run.scratch_po &&(
                                                    <ScratchPOModal button runID={run.id}/>
                                                )}
                                            </React.Fragment>
                                        )}
                                        {run && run.scratch_po && run.scratch_po.pdf_file && (
                                            <a
                                                href={run.scratch_po.pdf_file}
                                                className="btn btn-primary"
                                                role="button"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >Download Scratch PO (PDF)</a>
                                        )}
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        );
    }

    handleSubmit = (fn, data, {setSubmitting}) => {
        const res = {
            purchasing_group: data.purchasing_group,
            name: data.name,
            sap_top_wbs: data.sap_top_wbs,
            profit_center: data.profit_center,
            base_id: data.base_id
        };
        fn(utils.clearObjectNulls(res));
        setSubmitting(false);
    };
}
